module.exports = __webpack_public_path__ + "img/weather.8802d4ad.png";